import * as React from 'react';

interface Props {
  ariaName?: string;
}

export const Leaf: React.FunctionComponent<Props> = ({ ariaName }) => {
  return (
    <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        d="M6.5855 0C6.5855 0 5.79718 0.798236 4.94461 1.12006C-1.36894 3.50347 1.29375 8.14807 1.38062 8.16337C1.38062 8.16337 1.39673 7.51991 1.87497 7.15289C4.90972 4.82443 5.86445 2.14427 5.86445 2.14427C5.86445 2.14427 5.32483 5.36937 2.62497 7.37611C2.02867 7.8191 1.48352 8.90983 1.31261 10C1.31261 10 1.7353 9.82176 1.91706 9.77348C1.98794 9.29074 2.13613 8.82849 2.38666 8.41555C6.16004 8.88444 7.3959 5.71107 7.55734 4.60454C7.9384 1.99115 6.5855 0 6.5855 0Z"
        fill="#00AA3C"
      />
    </svg>
  );
};
